import { render, staticRenderFns } from "./header-default.vue?vue&type=template&id=60c87802&scoped=true"
import script from "./header-default.vue?vue&type=script&lang=ts"
export * from "./header-default.vue?vue&type=script&lang=ts"
import style0 from "./header-default.vue?vue&type=style&index=0&id=60c87802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c87802",
  null
  
)

export default component.exports